import { Action } from '@ngrx/store';
import { Keyword } from '../models/keywords.model';

export enum KeywordsActionTypes {
  KEYWORDS_QUERY = '[Keywords] Query',
  KEYWORDS_LOADED = '[Keywords] Fetched',

  KEYWORDS_ADDED = '[Keywords] Added',
  KEYWORDS_SUBTRACTED = '[Keywords] Subtracted',
  KEYWORDS_EDITED = '[Keywords] Edited',
  KEYWORDS_DELETED = '[Keywords] Deleted',

  KEYWORDS_ERROR = '[Keywords] Error'
}

export class KeywordsQuery implements Action {
  readonly type = KeywordsActionTypes.KEYWORDS_QUERY;
}

export class KeywordsLoaded implements Action {
  readonly type = KeywordsActionTypes.KEYWORDS_LOADED;

  constructor(public payload: { keywords: Keyword[] }) {}
}

export class KeywordsAdded implements Action {
  readonly type = KeywordsActionTypes.KEYWORDS_ADDED;

  constructor(public payload: { keyword: Keyword }) {}
} 

export class KeywordsSubtracted implements Action {
  readonly type = KeywordsActionTypes.KEYWORDS_SUBTRACTED;

  constructor(public payload: { keyword: Keyword }) {}
} 

export class KeywordsEdited implements Action {
  readonly type = KeywordsActionTypes.KEYWORDS_EDITED;

  constructor(public payload: { keyword: Keyword }) {}
}

export class KeywordsDeleted implements Action {
  readonly type = KeywordsActionTypes.KEYWORDS_DELETED;

  constructor(public payload: { keyword: Keyword }) {}
}

export class KeywordsError implements Action {
  readonly type = KeywordsActionTypes.KEYWORDS_ERROR;

  constructor(public payload: { error: any }) {}
}

export type KeywordsActions =
  | KeywordsQuery
  | KeywordsLoaded
  | KeywordsAdded
  | KeywordsSubtracted
  | KeywordsEdited
  | KeywordsDeleted
  | KeywordsError;
